import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "./layout/AppShell";
import { ProjectProvider } from "./layout/ProjectContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ManagementDashboard from "./pages/ManagementDashboard";
import ProjectSetup from "./pages/ProjectSetup";
import Activities from "./pages/Activities";
import Reports from "./pages/Reports";
import AlertProfiles from "./pages/AlertProfiles";
import DistortionPairs from "./pages/DistortionPairs";
import DeviceLogs from "./pages/DeviceLogs";

const App: React.FC = () => {
  return (
    <ProjectProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/select-role" element={<Landing />} />
        <Route element={<AppShell />}>
          <Route path="/reviewer/overview" element={<ManagementDashboard />} />
          <Route path="/reviewer/dashboard" element={<Dashboard />} />
          <Route path="/reviewer/reports" element={<Reports />} />
          <Route path="/admin/project-setup" element={<ProjectSetup />} />
          <Route path="/admin/activities" element={<Activities />} />
          <Route path="/admin/alert-profiles" element={<AlertProfiles />} />
          <Route path="/admin/distortion-pairs" element={<DistortionPairs />} />
          <Route path="/admin/device-logs" element={<DeviceLogs />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ProjectProvider>
  );
};

export default App;
